import { Button, Grid } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import moment from 'moment';
import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import advanced from "dayjs/plugin/advancedFormat";
require('dayjs/locale/ru')
import React from 'react';
import Breadcrumbs from '../../elements/Breadcrumbs';
import { Item, Text, Label, MainBlock, Header, InfoBlock, NextBtn, PrevBtn, CustomFooter, MobileHeader, ButtonsContainer } from './Finish.style';

dayjs.locale('ru');

dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.extend(advanced);

const timeZoneOffset = Number(localStorage.getItem('timeZoneOffset'));

const FinishMobile = ({
  isLoading,
  appointment,
  clinic,
  complete,
  cabinetName,
  user,
  onHandlePrevBtn,
  openLeftMenu
}) => {

  if (isLoading) {
    return <Skeleton variant="rect" height={500} />
  }

  return (
    <>
      <Breadcrumbs
        pathArr={[{ label: 'Запись на прием' }, { label: 'Информация о приеме' }]}
        payType={appointment.PayType === 'Cash' ? "Наличный расчет" : ""}
      />
      <MainBlock>
        <InfoBlock>

          <MobileHeader>
            Подтвердите запись на прием
          </MobileHeader>

          <ButtonsContainer>
            <Button variant='text' color='secondary' onClick={onHandlePrevBtn}>Отмена</Button>
            <Button variant='contained' color='secondary' onClick={complete}>Записаться</Button>
          </ButtonsContainer>

          <Grid container spacing={2} justify="space-between" >
            <Grid item xs={6} sm={6} md={4} >
              <Item>
                <Label>Пациент</Label>
                <Text>{user.lastName} {user.firstName} {user.middleName}</Text>
              </Item>
            </Grid>
            <Grid item xs={6} sm={6} md={4}>
              <Item>
                <Label>Дата рождения</Label>
                <Text>{user && moment(user.birthday).format('DD.MM.YYYY')}</Text>
              </Item>
            </Grid>
            <Grid item xs={6} sm={6} md={4}>
              <Item>
                <Label>Клиника</Label>
                <Text>{clinic.name}</Text>
              </Item>
            </Grid>
            <Grid item xs={6} sm={6} md={4}>
              <Item>
                <Label>Кабинет</Label>
                <Text>{cabinetName}</Text>
              </Item>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Item>
                <Label>Адрес</Label>
                <Text>{clinic && clinic.address}</Text>
              </Item>
            </Grid>
            <Grid item xs={6} sm={6} md={4}>
              <Item>
                <Label>{appointment && appointment.CategoryType === '0' ? 'Специализация' : 'Услуга'}</Label>
                <Text>{appointment && appointment.DoctorInfo && appointment.DoctorInfo.Specialization}</Text>
              </Item>
            </Grid>
            {appointment.PayType === 'Cash' &&
              <Grid item xs={6} sm={6} md={4}>
                <Item>
                  <Label>Цена</Label>
                  <Text>{appointment && appointment.Price / 100} руб.</Text>
                </Item>
              </Grid>
            }
            <Grid item xs={6} sm={6} md={4}>
              <Item>
                <Label>Дата</Label>
                <Text>{appointment && dayjs(appointment.AppointmentDateTime).utc().utcOffset(timeZoneOffset || 10).format('DD.MM.YYYY')}</Text>
              </Item>
            </Grid>
            <Grid item xs={6} sm={6} md={4}>
              <Item>
                <Label>Время</Label>
                <Text>{appointment && dayjs(appointment.AppointmentDateTime).utc().utcOffset(timeZoneOffset || 10).format('HH:mm')}</Text>
              </Item>
            </Grid>
          </Grid>

        </InfoBlock>

      </MainBlock>
    </ >
  )
}

export default FinishMobile;
